(() => {
  const videos = new Set();
  const displayed = (video) => video.getClientRects().length > 0 && getComputedStyle(video).visibility !== 'hidden';
  const inViewport = (video) => {
    const rect = video.getBoundingClientRect();
    return displayed(video) && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
  };
  const prepare = (video) => {
    if (!displayed(video) || !video.hasAttribute('data-hidock-lazy')) return;
    const mobileSource = matchMedia('(max-width: 699px)').matches ? video.dataset.hidockMobileSrc : '';
    const optimizedSource = video.dataset.hidockOptimizedSrc || mobileSource;
    video.querySelectorAll('source[data-hidock-src]').forEach((source) => {
      source.src = optimizedSource && source.type === 'video/mp4' ? optimizedSource : source.dataset.hidockSrc;
      source.removeAttribute('data-hidock-src');
    });
    video.removeAttribute('data-hidock-lazy');
    video.preload = 'metadata';
    video.load();
  };
  const sync = (video) => {
    if (document.hidden || !inViewport(video)) {
      video.pause();
      return;
    }
    prepare(video);
    if (!video.paused || video.hasAttribute('data-hidock-blocked')) return;
    video.play()?.catch((error) => {
      if (error.name === 'NotAllowedError') {
        video.setAttribute('data-hidock-blocked', '');
        video.controls = true;
        video.closest('video-media')?.setAttribute('suspended', '');
      }
    });
  };
  const ahead = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => { if (entry.isIntersecting && !document.hidden) prepare(entry.target); });
  }, { rootMargin: `${Math.min(innerHeight, 1000)}px 0px` }) : null;
  const visible = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => sync(entry.target));
  }, { threshold: 0 }) : null;
  const scan = (root = document) => {
    root.querySelectorAll('video[data-hidock-autoplay]').forEach((video) => {
      if (videos.has(video)) return;
      videos.add(video);
      const wrapper = video.closest('video-media');
      wrapper?.setAttribute('data-hidock-managed', '');
      wrapper?.setAttribute('loaded', '');
      video.addEventListener('canplay', () => wrapper?.setAttribute('can-play', ''));
      video.addEventListener('play', () => {
        if (document.hidden || !inViewport(video)) { video.pause(); return; }
        video.removeAttribute('data-hidock-blocked');
        wrapper?.setAttribute('playing', '');
        wrapper?.removeAttribute('suspended');
      });
      video.addEventListener('pause', () => wrapper?.removeAttribute('playing'));
      if (ahead) ahead.observe(video);
      if (visible) visible.observe(video);
      else sync(video);
    });
  };
  const refresh = () => {
    videos.forEach((video) => {
      if (!video.isConnected) {
        ahead?.unobserve(video);
        visible?.unobserve(video);
        videos.delete(video);
        return;
      }
      const rect = video.getBoundingClientRect();
      if (!document.hidden && rect.bottom > -innerHeight && rect.top < innerHeight * 2) prepare(video);
      sync(video);
    });
  };
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(refresh, 150);
  });
  document.addEventListener('visibilitychange', refresh);
  window.addEventListener('pageshow', refresh);
  window.addEventListener('pagehide', () => videos.forEach((video) => video.pause()));
  if (!visible) window.addEventListener('scroll', refresh, { passive: true });
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', refresh);
  scan();
})();

(() => {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  let widgetHiddenByCart = false;
  let timer;
  let attempts = 0;
  const syncWidget = () => {
    clearTimeout(timer);
    const open = drawer.hasAttribute('open');
    if (typeof window.zE !== 'function') {
      if (open && attempts++ < 30) timer = setTimeout(syncWidget, 1000);
      if (!open) attempts = 0;
      return;
    }
    if (open === widgetHiddenByCart) return;
    try {
      window.zE('messenger', open ? 'hide' : 'show');
      widgetHiddenByCart = open;
      attempts = 0;
    } catch (error) {
      if (open && attempts++ < 30) timer = setTimeout(syncWidget, 1000);
    }
  };
  new MutationObserver(syncWidget).observe(drawer, { attributes: true, attributeFilter: ['open'] });
  window.addEventListener('pageshow', syncWidget);
  window.addEventListener('pagehide', () => clearTimeout(timer));
  syncWidget();
})();
